//export default "http://localhost:2000";

export default "https://minitronix-web.vercel.app";